import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EventEmitterService } from 'app/service/event-emitter-service';
import { SolicitacaoService } from 'app/service/solicitacao/solicitacao.service';
import { param } from 'jquery';

@Component({
  selector: 'app-relatorio-controle',
  templateUrl: './relatorio-controle.component.html',
  styleUrls: ['./relatorio-controle.component.scss']
})
export class RelatorioControleComponent implements OnInit, OnDestroy {

  controleId;
  dateTime;
  controle;
  caixas = [];
  tipo;
  idControle;
  loading = false;

  constructor(
    private service: SolicitacaoService,
    private route: ActivatedRoute) {
    EventEmitterService.get("isPrintPage").emit(true);
    this.route.params.subscribe(params => this.controleId = params.id);
    this.route.params.subscribe(params => this.tipo = params.tipo);
   }
  

  ngOnInit() {
    if (this.tipo === '0') {
      this.controleUnico(this.controleId, 0);
    } else {
      this.controleUnico(this.controleId, 1);
    }
    var data = new Date;
    this.dateTime = data.toLocaleDateString('pt-BR');
  }

  ngOnDestroy(): void {
    EventEmitterService.get("isPrintPage").emit(false);
  }

  controleUnico(id, tipo) {
    this.service.controleUnico(id, tipo).subscribe(data => {
      this.controle = data;
      this.idControle = this.controle.id;
      this.caixas = this.controle.caixasControle;
    }, err => {
      console.error(err);
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/solicitacao/relatorio-controle/relatorio-controle.component.ts